import * as React from 'react';

import { BuilderLinkBlock } from '../../components/Builder/component/BuilderLinkBlock';
import { IStatsView } from '../../types/newbuilding/builder';

interface IBuilderHousesLinkProps {
  stats: IStatsView | null;
}

export function BuilderHousesLink({ stats }: IBuilderHousesLinkProps) {
  const { housesCount, housesText, newbuildingText, qs } = stats || {};

  if (!housesCount || !housesText || !newbuildingText || !qs) {
    return null;
  }

  return <BuilderLinkBlock count={housesCount} url={qs} housesText={housesText} newbuildingText={newbuildingText} />;
}
